// extracted by mini-css-extract-plugin
export default {"root":"qFC9XRcK","icon":"aEElVyeM","text":"lxVXxtk3","bold":"nx6cBXmL"};